import React from 'react'
import classes from './InfoForTabs.module.css'

interface InfoForTabsProps {
    imgSrc : string,
    title : string,
    desc : string
}

export default function InfoForTabs({imgSrc, title, desc} : InfoForTabsProps) {
  return (
      <div className={classes.container + ' flex flex-col lg:flex-row items-center w-10/12 mx-auto mt-top-vh5 justify-around lg:pb-vh10-bottom'}>
        <img src={imgSrc} className='md:w-full lg:w-6/12 mb-bottom-vh4 lg:mb-0'/>
        <div className='flex flex-col lg:w-6/12'>
            <h3 className='text-smTitlesForH md:text-mdTitlesForH lg:text-lgTitlesForH mb-3'>{title}</h3>
            <p className='text-smSepBtnTxt md:text-mdSepBtnTxt lg:text-lg2AddTxt '>{desc}</p>
        </div>
      </div>
  )
}
